<template>
  <div  class="explore-border">
    <div class="tips">Access from mainland China requires the use of a VPN. It is recommended to use Chrome or Safari version 14 or higher browsers.</div>

    <div class="search-box" v-loading="loading">
      <div class="check-brand" @click="showBrand"><div class="check-brand-text">{{checkedBrand}}</div><i class="el-icon-caret-right" v-if="!isShowBrand"></i><i class="el-icon-caret-bottom" v-if="isShowBrand"></i></div>
      <div class="check-state" @click="showState"><div class="check-state-text">{{checkedState}}</div><i class="el-icon-caret-right" v-if="!isShowState"></i><i class="el-icon-caret-bottom" v-if="isShowState"></i></div>
      <div class="check-category" @click="showCategory"><div class="check-category-text">{{checkedCategory}}</div><i class="el-icon-caret-right" v-if="!isShowCategory"></i><i class="el-icon-caret-bottom" v-if="isShowCategory"></i></div>
      <div class="check-store" @click="showStore"><div class="check-store-text">{{checkedStore}}</div><i class="el-icon-caret-right" v-if="!isShowStore"></i><i class="el-icon-caret-bottom" v-if="isShowStore"></i></div>
    </div>
    <div class="search-result" v-loading="loading">
      In the visible area, there are a total of <span class="search-result-total">{{storeTotal}}</span> stores.
    </div>
    <!-- 品牌的下拉框 -->
    <div v-if="isShowBrand" class="check-box">
      <div class="check-box-title">
        <div class="check-box-content">Select a Brand</div>
      </div>
      <el-radio-group v-model="checkboxBrandValue" size="mini" @change="changeBrand" >
        <el-radio v-for="brand in brandList" :label="brand.value" :key="brand.value" style="display: block; padding: 10px 0px;margin-left:5px">{{brand.label}}</el-radio>
      </el-radio-group>
    </div>
    <!-- 州的下拉框 -->
    <div v-if="isShowState" class="check-box">
      <div class="check-box-title">
        <div class="check-box-content">Select a State</div>
      </div>
      <el-radio-group v-model="checkboxStateValue" size="mini" @change="changeState">
        <el-radio v-for="state in stateList" :label="state.value"  :key="state.value" style="display: block; padding: 10px 0px;margin-left:5px">{{state.label}}</el-radio>
      </el-radio-group>
    </div>
    <!-- 分类的下拉框 -->
    <div v-if="isShowCategory" class="check-box">
      <div class="check-box-title">
        <div class="check-box-content">Select a Category</div>
      </div>
      <el-radio-group v-model="checkboxCategoryValue" size="mini" @change="changeCategory">
        <el-radio v-for="category in categoryList" :label="category.value"  :key="category.value" style="display: block;padding: 10px 0px;margin-left:5px">{{category.label}}</el-radio>
      </el-radio-group>
    </div>
    <!-- 店铺类型的下拉框 -->
    <div v-if="isShowStore" class="check-box">
      <div class="check-box-title">
        <div class="check-box-content">Select a Store</div>
      </div>
      <el-radio-group v-model="checkboxStoreValue" size="mini" @change="changeStore">
        <el-radio v-for="store in storeList" :label="store.value"  :key="store.value" style="display: block;padding: 10px 0px;margin-left:5px">{{store.label}}</el-radio>
      </el-radio-group>
    </div>
    <!-- <div id="map"></div> -->
    <GmapMap :center="center" :zoom="zoom" style="width: 100%; height: 100%">
      <GmapCluster
        :imagePath="imgPath"
        :imageSizes="[82,93]"
        :zoomOnClick="true"
        :enableRetinaIcons="true">
        <GmapMarker v-for="(localtion, index) in locations"
                    :label="localtion.label"
                    :position="localtion.position"
                    :clickable="true"
                    :key="index"
                    :icon="localtion.icon"
                    @click="openInfoWindow(localtion)"
        >
          <GmapInfoWindow v-if="localtion.show" :position="localtion.position">
            <div style="border-radius: 10px; position:relative; width: 240px; height: auto;cursor:pointer;" @click="gotoCustomer(localtion)">
              <img v-if="localtion.img" style="display: block; width: 240px; height: 95px; object-fit: cover" :src="localtion.img" />
              <div class="ellipsis" style="text-align: left; padding: 0 10px; width: 240px; margin-top: 5px; font-size: 15px; font-weight: bold;">{{ localtion.storeName }}</div>
              <div class="ellipsis" style="text-align: left; padding: 0 10px; height: 20px">{{ localtion.storeAddress }}</div>
              <div class="maps-btn">
                  <div @click.stop="zoomIn(localtion)"><i class="el-icon-zoom-in"/></div>
                  <div @click.stop="gotoReport(localtion)">Open Report</div>
              </div>
            </div>
          </GmapInfoWindow>
        </GmapMarker>
      </GmapCluster>
    </GmapMap>
  </div>

</template>

<script>
import stateUtils from '../../utils/state'
// import { MarkerClusterer } from '@googlemaps/markerclusterer'
import {getAction} from '../../api/manage'
import notRegShop from '../../utils/not-reg-shop'

export default {
  data() {
    return {
      imgPath: 'https://master-shopvidi.s3.amazonaws.com/common/test/2023101919/b4aeedf9-0972-43a9-8024-5a741aceb82011',
      center: {},
      zoom: '',
      restriction: {
        latLngBounds: {
          north: 52.532837,
          south: 23.701518,
          west: -130.152723,
          east: -66.341519
        },
        strictBounds: false
      },
      checkedBrand: 'All Brand',
      checkedState: 'Georgia',
      checkedCategory: 'All Category',
      checkedStore: 'All Store',
      isShowBrand: false,
      isShowState: false,
      isShowCategory: false,
      isShowStore: false,
      isShowCheckBox: false,
      isFirstLoad: true,
      loading: false,
      storeTotal: 0,
      // 品牌部分
      checkboxBrandValue: '',
      brandList: [
        {'label': 'All Brands', 'value': ''}
      ],
      brandsForm: {
        pageSize: 10000,
        currentPage: 1
      },
      // 州部分
      checkboxStateValue: 'GA',
      stateList: stateUtils.stateArr,
      // 分类部分
      checkboxCategoryValue: '',
      categoryList: [
        {'label': 'All Category', 'value': ''}
      ],
      // 店铺部分
      checkboxStoreValue: '',
      storeList: [
        {'label': 'All Store', 'value': ''},
        {'label': 'V Store', 'value': 'vilocal'}
      ],
      locations: [],
      notRegLocalsArr: [],
      intervalId: ''
    }
  },
  created() {
    // 获取品牌信息
    this.getBrandList()
    // 获取分类信息
    this.getCategoryList()
    // 进入获取数据
    this.loadData()
    // 未注册店铺
    // this.buildNotRegLocalsArr()
  },
  mounted() {

  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
  methods: {
    async buildNotRegLocalsArr() {
      notRegShop.notRegShopArr.forEach(localtion => {
        this.rebuildLocaltion(localtion)
        this.notRegLocalsArr.push(localtion)
      })
      console.log('未注册店铺push 完毕。')
    },
    clusteredMarkers(event) {
      console.log(event.center)
    },
    uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0
        var v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      }) + Math.floor(Math.random() * 10000 + 1)
    },
    gotoCustomer(location) {
      // add by cpgu 2023/11/08 未注册客户不做跳转 begin
      if (location.userId === '1' || location.userId === '-1') {
        console.log('not reg')
        return
      }
      // end by cpgu

      // 判断角色，如果是Demo不能跳转
      let userInfo = JSON.parse(localStorage.getItem('pro__userInfo'))
      if (userInfo.value.model !== '100') {
        window.open(window.location.origin + '/menu/CustomersDetail?userId=' + location.userId)
      }
    },
    openInfoWindow(location) {
      const locationNew = JSON.parse(JSON.stringify(location))
      // 点击marker后，先将所有marker的show属性设置为false
      this.locations = this.locations.map((item) => {
        item.show = false
        return item
      })

      const params = {}
      params.input = location.storeName
      params.lat = location.position.lat
      params.lng = location.position.lng
      // 第一步用店铺名称和经纬度查找出 google地址ID
      getAction('/register/place/photo', params).then(response => {
        if (response.success) {
          if (response.result) {
            const imageUrl = 'https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&photo_reference=' + response.result + '&key=AIzaSyCn2jsrZGPsmJ_k1gMGw_xGEX1r__7EchQ'
            location.img = imageUrl
            this.locations = this.locations.map((item) => {
              if (item.id === location.id) {
                item.show = !locationNew.show
              }
              return item
            })
          } else {
            this.locations = this.locations.map((item) => {
              if (item.id === location.id) {
                item.show = !locationNew.show
              }
              return item
            })
          }
        } else {
          this.locations = this.locations.map((item) => {
            if (item.id === location.id) {
              item.show = !locationNew.show
            }
            return item
          })
        }
      })
    },

    async loadData() {
      try {
        clearInterval(this.intervalId)
      } catch (e) {
        console.log('此异常吃掉，不处理。')
      }

      this.zoom = 4
      this.center = {}
      if (this.loading) {
        return
      }

      this.locations = []
      // 准备请求后端
      this.loading = true
      // 请求参数
      const params = {}
      if (this.checkboxStateValue) {
        params.state = this.checkedState
        params.abbrState = this.checkboxStateValue
      }
      if (this.checkboxCategoryValue) {
        params.categoryId = this.checkboxCategoryValue
      }
      if (this.checkboxStoreValue) {
        params.storeType = this.checkboxStoreValue
      }
      if (this.checkboxBrandValue) {
        params.brandIds = this.checkboxBrandValue
      }
      let response = await getAction('/sp/suppliers/shop/list', params)
      // .then(response => {
      if (response.success) {
        // this.loading = false
        this.storeTotal = 0
        if (response.result && response.result.length > 0) {
          let locationList = []
          for (var index = 0; index < response.result.length; index++) {
            let localtion = response.result[index]
            this.rebuildLocaltion(localtion)
            locationList.push(localtion)
          }
          this.locations = locationList
          this.storeTotal = this.locations.length

          // add by cpgu 2023/11/22 begin
          if (!this.checkboxStateValue && !this.checkboxCategoryValue && !this.checkboxStoreValue && !this.checkboxBrandValue) {
            let newTotal = (this.storeTotal + notRegShop.notRegShopArr.length)
            this.storeTotal = newTotal
            // this.locations = [...this.locations,...this.notRegLocalsArr]
            /* this.notRegLocalsArr.forEach(info=>{
                this.locations.push(info)
              }) */
          }
          // end by cpgu

          this.zoom = 4
          this.center = {
            lat: 39.8283,
            lng: -98.5795
          }
        } else {
          this.zoom = 4
          this.center = {
            lat: 39.8283,
            lng: -98.5795
          }
        }
      } else {
        this.$message.warning(response.message)
        // this.loading = false
        this.zoom = 4
        this.center = {
          lat: 39.8283,
          lng: -98.5795
        }
      }
      // })

      // add by cpgu 2023/11/23 begin
      // 第一次loading后再持续3.5秒，便于push 进this.notRegLocalsArr
      if (this.isFirstLoad) {
        let that = this
        setTimeout(function () {
          that.loading = false
        }, 3500)
        this.isFirstLoad = false
      } else {
        this.loading = false
      }

      await this.loadNotRegUser()

      // end by cpgu
    },
    async loadNotRegUser() {
      if (!this.checkboxStateValue && !this.checkboxCategoryValue && !this.checkboxStoreValue && !this.checkboxBrandValue) {
        // this.locations = [...this.locations,...this.notRegLocalsArr]
        let that = this
        // setTimeout(function (){
        if (that.notRegLocalsArr.length == 0) {
          await that.buildNotRegLocalsArr()
        }

        console.log('>>添加未注册用户>，当前未注册店铺个数：', that.notRegLocalsArr.length)
        // 太慢，更改为后续
        // that.locations = [...that.locations,...that.notRegLocalsArr]

        // 分页push，没达到效果
        /* const chunkSize = 500;
          let len = that.notRegLocalsArr.length
          for (let i = 0; i < len; i += chunkSize) {
            const chunk = that.notRegLocalsArr.slice(i, i + chunkSize);
            that.locations.push(...chunk);
          } */

        // 暂停的毫秒数
        const delay = 500
        let index = 0
        const chunkSize = 1000
        let len = that.notRegLocalsArr.length
        this.intervalId = setInterval(() => {
          // 每次遍历10个元素后，执行一次该块代码
          if (index % chunkSize === 0) {
            console.log(`暂停 ${delay} 毫秒`)
            setTimeout(() => {
              // 暂停结束后，继续遍历
              console.log(`继续遍历`)
            }, delay)
          }
          // 遍历数组并打印元素
          for (let i = 0; i < chunkSize; i++) {
            if (index + i < len) {
              let obj = that.notRegLocalsArr[index + i]
              that.locations.push(obj)
            }
          }

          index += chunkSize

          // 如果遍历完数组，清除定时器
          if (index >= len) {
            console.log('>>添加未注册用户-完成>')
            clearInterval(that.intervalId)
          }
        }, delay)

        // console.log(">>添加未注册用户-完成>")

        // },100)
      }
    },
    rebuildLocaltion(localtion) {
      localtion.position.lat = parseFloat(localtion.position.lat)
      localtion.position.lng = parseFloat(localtion.position.lng)
      localtion.id = this.uuid()
      const icon = {}
      const label = {}
      // 非vilocal 150*30
      icon.url = 'https://s3-amazonaws.shopvidi.com/common/test/2023101912/1629397312189898754/picture-library/09cf9c25-da66-4f6a-aa29-3a2b34ec30d0.png'
      label.color = '#000000'
      label.text = localtion.storeName
      label.fontSize = '14px'
      label.fontWeight = '600'
      label.textAlign = 'center'
      if (localtion.isVilocal) {
        label.color = '#FFFFFF'
        label.text = localtion.storeName + '【V Store】'
        // vilocal 150*30
        icon.url = 'https://s3-amazonaws.shopvidi.com/common/test/2023101911/1629397312189898754/picture-library/f569d0b0-6a3f-4d9a-8e31-e9cec10c4312.png'
        if (label.text.length >= 20 && label.text.length < 25) {
          // 200 * 30
          icon.url = 'https://s3-amazonaws.shopvidi.com/common/test/2023101912/1629397312189898754/picture-library/971f7475-d804-46af-9969-87f81f28c348.png'
          icon.size = new google.maps.Size(200, 35)
        } else if (label.text.length >= 25 && label.text.length < 30) {
          // 250 * 30
          icon.url = 'https://s3-amazonaws.shopvidi.com/common/test/2023101912/1629397312189898754/picture-library/724db2d2-5c35-40dd-aea2-fda4d6fb054a.png'
          icon.size = new google.maps.Size(250, 35)
        } else if (label.text.length >= 30) {
          if (label.text.length > 38) {
            label.text = label.text.substring(0, 38) + '..'
          }
          // 300*30
          icon.url = 'https://s3-amazonaws.shopvidi.com/common/test/2023101912/1629397312189898754/picture-library/696a21f0-78f1-4d03-8772-940e66565b61.png'
          icon.size = new google.maps.Size(300, 35)
        }
      } else {
        if (label.text.length >= 20 && label.text.length < 25) {
          icon.url = 'https://s3-amazonaws.shopvidi.com/common/test/2023101912/1629397312189898754/picture-library/bc4a6063-8304-46b3-8c9c-f3cad4ca7fe0.png'
          icon.size = new google.maps.Size(200, 35)
        } else if (label.text.length >= 25 && label.text.length < 30) {
          // 250 * 30
          icon.url = 'https://s3-amazonaws.shopvidi.com/common/test/2023101912/1629397312189898754/picture-library/e107b3b7-d86b-4f2b-abed-7f5e1093d1c4.png'
          icon.size = new google.maps.Size(250, 35)
        } else if (label.text.length >= 30) {
          if (label.text.length > 38) {
            label.text = label.text.substring(0, 38) + '..'
          }

          // 300*30
          icon.url = 'https://s3-amazonaws.shopvidi.com/common/test/2023101912/1629397312189898754/picture-library/9fe4d819-0f63-4581-8fd2-1032df51d3f9.png'
          icon.size = new google.maps.Size(300, 35)
        }
      }
      localtion.icon = icon
      localtion.label = label
      return localtion
    },
    getCategoryList() {
      getAction('tsCategory/tsCateInfo/all-list').then(response => {
        if (response.success) {
          const responseCategoryList = response.result.map((item) => {
            const categoryObject = {}
            categoryObject.label = item.cateName
            categoryObject.value = item.id
            return categoryObject
          })
          Array.prototype.push.apply(this.categoryList, responseCategoryList)
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    getBrandList() {
      // 查询当前的角色，如果是Demo角色那么就查询当前用户绑定的品牌
      let userInfo = JSON.parse(localStorage.getItem('pro__userInfo'))
      // 如果是运营或者DEMO就查询所有品牌
      if (userInfo.value.model === '100' || userInfo.value.model === '4') {
        getAction('/brand/api/v0.2/brands').then(response => {
          if (response.success) {
            const responseBrandList = response.result.map((item) => {
              const brandObject = {}
              brandObject.label = item.brandName
              brandObject.value = item.id
              return brandObject
            })
            Array.prototype.push.apply(this.brandList, responseBrandList)
          } else {
            this.$message.warning(response.message)
          }
        })
        return
      }
      // 不是运营或者DEMO角色就查询绑定的品牌
      getAction('/sp/suppliers/brand', this.brandsForm).then(response => {
        if (response.success) {
          const responseBrandList = response.result.records.map((item) => {
            const brandObject = {}
            brandObject.label = item.brandName
            brandObject.value = item.id
            return brandObject
          })
          Array.prototype.push.apply(this.brandList, responseBrandList)
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    changeStore(value) {
      const checkedStore = this.storeList.filter(f => f.value === value)
      if (checkedStore) {
        this.checkedStore = checkedStore[0].label
        // 关闭弹框
        this.isShowStore = false
        // 请求数据
        this.loadData()
      }
    },
    changeCategory(value) {
      // 这里面需要写逻辑 找出value对应的lable 向后端查询数据
      const checkedCategory = this.categoryList.filter(f => f.value === value)
      if (checkedCategory) {
        this.checkedCategory = checkedCategory[0].label
        // 关闭弹框
        this.isShowCategory = false
        // 请求数据
        this.loadData()
      }
    },
    changeState(value) {
      // 这里面需要写逻辑 找出value对应的lable 向后端查询数据
      const checkedState = this.stateList.filter(f => f.value === value)
      if (checkedState) {
        this.checkedState = checkedState[0].label
        // 关闭弹框
        this.isShowState = false
        // 请求数据
        this.loadData()
      }
    },
    changeBrand(value) {
      // 这里面需要写逻辑 找出value对应的lable 向后端查询数据
      const checkedBrand = this.brandList.filter(f => f.value === value)
      if (checkedBrand) {
        this.checkedBrand = checkedBrand[0].label
        // 关闭弹框
        this.isShowBrand = false
        // 请求数据
        this.loadData()
      }
    },
    showStore() {
      this.isShowStore = !this.isShowStore
      if (this.isShowStore) {
        this.isShowCategory = false
        this.isShowState = false
        this.isShowBrand = false
      }
    },
    showCategory() {
      this.isShowCategory = !this.isShowCategory
      if (this.isShowCategory) {
        this.isShowState = false
        this.isShowBrand = false
        this.isShowStore = false
      }
    },
    showState() {
      this.isShowState = !this.isShowState
      if (this.isShowState) {
        this.isShowBrand = false
        this.isShowStore = false
        this.isShowCategory = false
      }
    },
    showBrand() {
      this.isShowBrand = !this.isShowBrand
      if (this.isShowBrand) {
        this.isShowStore = false
        this.isShowCategory = false
        this.isShowState = false
      }
    },
    zoomIn(location){
      this.zoom = 20
      this.center = location.position
    },
    gotoReport(location) {
    /*  if (location.userId === '1') {
        console.log('not reg:gotoReport')
        return
      }*/
      console.log("gotoReport...",location)
      var encrypt = btoa(location['googleStoreId'])
      const routeUrl = this.$router.resolve(`/menu/Explore?isReport=1&userId=${location.userId}&storeId=${encrypt}&storeName=${location['storeName']}&storeAddress=${location['storeAddress']}`);
      window.open(routeUrl.href, '_blank');

    },
    getMap() {
      // const map = new google.maps.Map(document.getElementById('map'), {
      //   zoom: 5,
      //   restriction: {
      //     latLngBounds: {
      //       north: 52.532837,
      //       south: 23.701518,
      //       west: -130.152723,
      //       east: -66.341519
      //     },
      //     strictBounds: false
      //   }
      // })
      // map.setCenter({ lat: 39.8283, lng: -98.5795 })
      // const infoWindow = new google.maps.InfoWindow({
      //   content: '',
      //   disableAutoPan: true
      // })
      // // Add some markers to the map.
      // let markers = []
      // markers = this.locations.map((position, i) => {
      //   const label = position.storeName
      //   const marker = new google.maps.Marker({
      //     position: position.position,
      //     labelContent: {
      //       color: '#FFFFFF', // 设置颜色
      //       text: label
      //     }
      //   })

      //   // markers can only be keyboard focusable when they have click listeners
      //   // open info window when marker is clicked
      //   marker.addListener('click', () => {
      //     infoWindow.setContent(label)
      //     infoWindow.open(map, marker)
      //   })
      //   return marker
      // })

      // // Add a marker clusterer to manage the markers.
      // return new MarkerClusterer({ markers, map })
    }
  }
}
</script>

<style lang="less" scoped>
.explore-border{
  height: calc(100vh - 120px);
}
#map {
  height: 90%;
}
/deep/ .gm-style-mtc{
  display: none;
}
.search-result{
  position: absolute;
  // top: 165px;
  // left: 270px;
  top: 80px;
  left: 20px;
  z-index: 9999;
  background: white;
  border: 1px solid #D8D8D8;
  border-radius: 5px;
  padding: 5px 0px 5px 15px;
  font-family: Satoshi-Medium !important;
  font-size: 14px;
  width: 454px;
  .search-result-total{
    color: #FF4812;
    font-family: Satoshi-Medium !important;
  }
}
.search-box{
  position: absolute;
  // top: 115px;
  // left: 270px;
  top: 30px;
  left: 20px;
  z-index: 9999;
  background: white;
  padding: 10px;
  border: 1px solid #D8D8D8;
  border-radius: 5px;
  display: flex;
  .check-brand,.check-state,.check-category,.check-store{
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: #262B2F;
    display: flex;
    align-items: center;
  }
}
.check-box{
  position: absolute;
  width: 576.26px;
  top: 80px;
  left: 20px;
  z-index: 9999;
  background: white;
  padding: 10px;
  border: 1px solid #D8D8D8;
  border-radius: 5px;
  height: 400px;
  overflow-y:auto;
  .check-box-title{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .check-box-content,.check-box-all{
      font-family: Satoshi-Medium !important;
      font-size: 14px;
      color: #000000;
    }
    .check-box-all{
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
.check-brand-text,.check-state-text,.check-category-text,.check-store-text{
  font-family: Satoshi-Medium !important;
  margin-left: 10px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.check-brand-text{
  width: 130px;
}
.check-state-text{
  width: 100px;
}
.check-category-text{
  width: 120px;
}
.check-store-text{
  width: 80px;
}
.el-icon-caret-right,.el-icon-caret-bottom{
  color: #8F8F8F;
  margin-left: 10px;
}
/deep/ .gm-style-iw {
  padding: 0 !important;
  margin: 0 !important;
}
/deep/ .gm-style .gm-style-iw-d {
  overflow: hidden !important;
}
/deep/ .gm-style-iw button {
  display: none !important;
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .cluster{
  div{
    color: #000000 !important;
    width: 82px !important;
    line-height: 93px !important;
  }
}
.tips{
  font-family:Satoshi-Bold !important;
  font-size: 12px;
  // margin-top: -15px;
  padding-bottom: 5px;
  color: #FF4812;
}
.maps-btn{
  display: flex;
  justify-content: space-around;
  margin: 5px 0;
  height: 30px;
  div{
    cursor:pointer;
    line-height: 30px;
  }
  div:nth-child(1){
    padding: 10px;
    border: 1px solid #E1E1E1;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
   div:nth-child(2){
     width: 180px;
     color: #F3E93D;
     background: #262B2F;
     text-align: center;
     border-radius: 3px;

   }
}
</style>




// WEBPACK FOOTER //
// src/pages/vilocal/explore-google-maps.vue